module.exports = __webpack_public_path__ + "static/media/options.1d847ccd.svg";